var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home_container flex-center"},[_c('div',{staticClass:"wrapper"},[_c('network-disk',{staticStyle:{"width":"1200px"},attrs:{"fileType":_vm.fileType,"boxHeight":800}}),_c('resource-high')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }